import { CoachProfile } from "@joonapp/web-shared"
import { ClientProfile } from "@joonapp/web-shared"
import { UserRole } from "@joonapp/web-shared"
import dayjs from "dayjs"

export const checkCoachMessageAlerts = (
  sender: ClientProfile | CoachProfile | undefined,
  date: number | string | undefined
) => {
  if (!date || !sender)
    return {
      showCoachMessageAlert: false,
      showClientMessageAlert: false,
      messageDaysAgo: 0,
    }
  const isMoreThan24HoursAgo = dayjs(date).isBefore(
    dayjs().subtract(24, "hour")
  )
  const messageDaysAgo = Math.abs(dayjs(date).diff(dayjs(), "day"))
  const isMoreThan7DaysAgo = messageDaysAgo >= 7

  const showCoachMessageAlert =
    ( !sender || sender.role === UserRole.COACH) && isMoreThan7DaysAgo
  const showClientMessageAlert =
    sender?.role === UserRole.CLIENT && isMoreThan24HoursAgo

  return {
    showCoachMessageAlert,
    showClientMessageAlert,
    messageDaysAgo,
  }
}
